var PropTypes = require('prop-types');
let React = require('react');
let Modal = require('react-bootstrap').Modal;

let custPrefsApi = require('../../api/custPrefs.jsx');

import {FormattedMessage, injectIntl} from 'react-intl';

// Row object
class ExitPrompt extends React.Component {
  static propTypes = {
    showState: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    preferences: PropTypes.object.isRequired,
  };

  state = {
    showNotifModalState: false,
  };

  closeModal = () => {
    this.props.hideModal();
  };

  save = () => {
    //Based on checkboxes make our email preferences for customer
    let preferences = this.props.preferences;

    custPrefsApi.saveCustomerEmailPreferences(preferences)
      .then(() => {
        window.close();
      });
  };

  render() {
    let show = this.props.showState;

    if (show) {
      return (
        <Modal className="body-container" show={show} onHide={this.props.hideModal} >
          <Modal.Header>
            <Modal.Title><FormattedMessage id="manifold.save.before.exit"/></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <span><FormattedMessage id="manifold.exit.warning"/></span>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn-secondary" onClick={() => this.closeModal()}><FormattedMessage id="manifold.not.save"/></button>
            <button className="btn-primary" onClick={() => this.save()}><FormattedMessage id="manifold.save.changes"/></button>
          </Modal.Footer>
        </Modal>
      );
    }

    return <div id='notifModal'/>;
  }
}

export default injectIntl(ExitPrompt);

